import { render, staticRenderFns } from "./projectStt.vue?vue&type=template&id=49fffd50"
import script from "./projectStt.vue?vue&type=script&lang=js"
export * from "./projectStt.vue?vue&type=script&lang=js"
import style0 from "./projectStt.vue?vue&type=style&index=0&id=49fffd50&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports